



import React, { useState } from 'react';
import MRideDetails from './MRideDetails';
import { FaArrowLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom'; // Import useNavigate

const MBookingCard = () => {
  const [isModalOpen, setModalOpen] = useState(false);
  const toggleModal = () => setModalOpen(!isModalOpen);
  const navigate = useNavigate(); // Initialize navigate function

  const handleBack = () => {
    navigate(0);
  };
  return (
    <div className="flex min-h-screen bg-white w-full mx-auto rounded-lg">
      <div className="w-full rounded-lg shadow-md ">
              <div className="w-full bg-[#FF9630] text-white py-4 px-6 flex items-center">
                <button onClick={handleBack} className="mr-4 text-white hover:text-gray-200">
                  <FaArrowLeft className="text-lg" />
                </button>
                <h1 className="text-xl font-semibold">My Ride</h1>
              </div>
        <div className="bg-gray-100 p-4 rounded-md">
          {/* Dates and Times */}
          <div className="flex justify-between items-center mb-4 text-sm text-gray-800">
            <div className="text-center">
              <p>08 Oct 2024</p>
              <p>09:00 AM</p>
            </div>
            <p>to</p>
            <div className="text-center">
              <p>08 Oct 2024</p>
              <p>09:00 PM</p>
            </div>
          </div>

          {/* Booking Details */}
          <div className="grid grid-cols-2 gap-4 text-sm text-gray-700">
            <p className="text-left">Location</p>
            <p className="font-semibold text-right">Cantonment complex, Opp Mangesh Honda</p>
            <p className="text-left">Booking ID</p>
            <p className="text-right">240807001005</p>
            <p className="text-left">Total Amount</p>
            <p className="text-right">₹900.00</p>
            <p className="text-left">Booking Status</p>
            <p className="text-right text-green-500 font-semibold">Ongoing</p>
          </div>

          {/* More Details Link */}
          <div className="text-right mt-4">
            <button
              onClick={toggleModal}
              className="text-[#FF9630] font-semibold hover:underline focus:outline-none"
            >
              More Details &rarr;
            </button>
          </div>
        </div>
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex justify-center items-center">
          <div className="bg-white w-full h-full md:w-3/4 lg:w-2/3 rounded-lg shadow-lg overflow-auto">
            {/* Modal Content */}
            <MRideDetails />
            {/* Close Button */}
            <div className="absolute top-4 right-4">
              {/* <button
                onClick={toggleModal}
                className="text-gray-500 hover:text-gray-800 focus:outline-none text-2xl"
              >
                &times;
              </button> */}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MBookingCard;

